import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';

export const setModalConfig =
  (value: any, fieldName: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_MODAL_CONFIG,
      payload: { value: value, fieldName: fieldName },
    });
  };
